import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../components/forms/input.component';
import Icon from '../../../../components/forms/icon.component';

interface OfferCodeBtnProps {
  errors: any;
  register: any;
  watch: any;
  index: number;
  onDelete: () => void;
}

const OfferCodeBtn = ({ errors, register, watch, index, onDelete }: OfferCodeBtnProps) => {
  const { t } = useTranslation();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, maxLength: number) => {
    const currentLength = e.currentTarget.value.length;
    if (currentLength >= maxLength && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  return (
    <div className="border p-7 mt-4">
      <div className="mb-2">
        <Icon icon="ki-copy" size="fs-1 me-2" />
        {t('templates.wa.create.copy-offer-code')}
      </div>
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <Input
              label={t('templates.wa.create.copy-offer-code')}
              errors={errors?.offer_code}
              requiredIndicator="required"
              currentLength={watch(`buttons.buttons.${index}.example`)?.length}
              maxLength={15}
              placeholder={t('templates.wa.create.offer-code-placeholder')}
              onKeyDown={(e: any) => handleKeyDown(e, 15)}
              {...register(`buttons.buttons.${index}.example`, {
                required: true,
                maxLength: { value: 15, message: '15' },
                setValueAs: (value: string) => value.trim()
              })}
            />
          </div>
          <div className="d-flex flex-column align-items-center">
            <a className="btn btn-light-danger btn-icon ms-3 mt-2" onClick={onDelete}>
              <Icon icon="ki-trash" size="fs-2x" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferCodeBtn;
